module.exports = __webpack_public_path__ + "static/media/024.c2fee5dc.png";